import React from 'react'
import MaterialSymbol from '../material-symbol'

const EventRepeat = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="event_repeat" {...props} />
))

EventRepeat.displayName = 'EventRepeat'

export default EventRepeat
